import {Logo} from './Logo';
import {Button} from './Button';
import {Rating} from './Rating';
import {Header} from './Header';
import {Socials} from './Socials';
import {LazyImage} from './LazyImage';
import {Background} from './Background';
import {ScrollToTop} from './ScrollToTop';
import {RatingStars} from './RatingStars';
import {BlockHeading} from './BlockHeading';
import {BottomTabBar} from '../navigation/BottomTabBar';

export const components = {
  Logo,
  Button,
  Header,
  Rating,
  Socials,
  LazyImage,
  Background,
  RatingStars,
  ScrollToTop,
  BottomTabBar,
  BlockHeading,
};
